import { Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';

interface DigitalWalletsWrapperProps {
  children: React.ReactNode;
  titleId?: string;
}

export function DigitalWalletsWrapper({
  children,
  titleId,
}: DigitalWalletsWrapperProps) {
  const intl = useIntl();

  return (
    <div className='border-0' data-testid='digital-wallet-choice'>
      {titleId && (
        <div className="mb-jade-200">
          <Text color="current-color" variant="heading-small">
            {intl.formatMessage({ id: titleId })}
          </Text>
        </div>
      )}
      <div className='flex items-center gap-jade-200'>{children}</div>
    </div>
  );
}
